// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3sr1g","itemTitle":"ClientEmergencyInfo_itemTitle__1Xm4F","itemText":"ClientEmergencyInfo_itemText__3daLo"};